module.exports = __webpack_public_path__ + "static/media/astrologer_banner.a7f4352f.png";